export async function getList({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.categories.index();
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function getTree({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.categories.getTree();
  if (!errResponse && responseData.success) {
    return commit('setTree', responseData.data);
  }

  return [];
}

export async function deleteCategoryById({commit}, payload) {
  const response = await this.$adminRepositories.categories.delete(payload);
  return response;
}

export async function createCategory({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.categories.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateCategory({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.categories.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findCategoryById(_, payload) {
  return await this.$adminRepositories.categories.show(payload);
}
